"use client"

const TableOfContentAnchor = ({ anchorId, text }) => {
  return (
    <a
      href={`#${anchorId}`}
      className="jlt-select-none !jlt-text-foreground hover:jlt-text-[var(--primary)] jlt-transition-all jlt-duration-150 hover:jlt-underline"
      onClick={(e) => {
        e.preventDefault();
        const foundDOM = document.getElementById(anchorId);
        if(foundDOM) {
          foundDOM.scrollIntoView({
            behavior: "smooth",
          });
        }
        
      }}
      dangerouslySetInnerHTML={{ __html: text || "" }}
    />
  );
};

export default TableOfContentAnchor;